import { wrapEmail, htmlEscape, paragraphsToHtml, ctaButton, heroImage, divider, assertNoUnsubstitutedTokens } from './_shared.js';

const MAX_STORIES = 4;

export default {
  id: 'newsletter',
  name: 'Newsletter / Multi-section',
  description: 'Hero + intro + up to 4 story blocks (title, body, optional image, optional CTA).',
  slots: [
    { id: 'preheader', label: 'Preview text',  type: 'text',     optional: true, maxLen: 140 },
    { id: 'hero',      label: 'Hero image URL', type: 'image',    optional: true },
    { id: 'eyebrow',   label: 'Eyebrow label',  type: 'text',     optional: true, maxLen: 40,
      hint: 'e.g. "Monthly update" or "Issue 14".' },
    { id: 'headline',  label: 'Issue headline', type: 'text',     optional: true, maxLen: 80 },
    { id: 'intro',     label: 'Intro paragraph', type: 'longtext', optional: true },
    { id: 'stories',   label: 'Stories',         type: 'stories',  optional: false, max: MAX_STORIES },
  ],
  storySlots: [
    { id: 'title',       label: 'Story title',  type: 'text',     optional: false, maxLen: 100 },
    { id: 'body',        label: 'Story body',   type: 'longtext', optional: false },
    { id: 'image',       label: 'Image URL',    type: 'image',    optional: true },
    { id: 'buttonLabel', label: 'Button label', type: 'text',     optional: true, pairsWith: 'buttonUrl' },
    { id: 'buttonUrl',   label: 'Button URL',   type: 'url',      optional: true, pairsWith: 'buttonLabel' },
  ],
  maxStories: MAX_STORIES,
  render(content, branding, footer, options) {
    const c = content || {};
    const ff = (branding && branding.fontFamily) || 'Arial';
    const accent = (branding && branding.primaryColour) || '#00897b';
    const hidden = new Set(c.slotsHidden || []);
    const stories = (c.stories || []).filter((s) => s && (s.title || s.body));

    const inner = `
      ${!hidden.has('hero') && c.hero ? heroImage(c.hero, c.headline || '') : ''}
      ${!hidden.has('eyebrow') && c.eyebrow ? `<p style="margin: 0 0 8px; font-family: ${ff}, Helvetica, Arial, sans-serif; font-size: 12px; font-weight: 600; letter-spacing: 0.12em; text-transform: uppercase; color: ${htmlEscape(accent)};">${htmlEscape(c.eyebrow)}</p>` : ''}
      ${c.headline ? `<h1 class="headline dark-text" style="margin: 0 0 16px; font-family: ${ff}, Helvetica, Arial, sans-serif; font-size: 28px; font-weight: 700; line-height: 1.22; letter-spacing: -0.015em; color: #111827;">${htmlEscape(c.headline)}</h1>` : ''}
      ${!hidden.has('intro') && c.intro ? paragraphsToHtml(c.intro, ff) : ''}
      ${stories
        .map(
          (s, i) => `
        ${i === 0 && (c.intro || c.headline || (!hidden.has('hero') && c.hero)) ? divider(branding) : i > 0 ? divider(branding) : ''}
        <h2 class="story-title dark-text" style="margin: 0 0 12px; font-family: ${ff}, Helvetica, Arial, sans-serif; font-size: 20px; font-weight: 600; line-height: 1.3; color: #111827;">${htmlEscape(s.title || '')}</h2>
        ${s.image ? heroImage(s.image, s.title) : ''}
        ${paragraphsToHtml(s.body, ff)}
        ${s.buttonLabel && s.buttonUrl ? ctaButton(s.buttonLabel, s.buttonUrl, branding) : ''}`,
        )
        .join('')}
    `;
    const html = wrapEmail(inner, branding, footer, {
      ...options,
      preheader: c.preheader || c.intro?.split('\n')[0] || c.headline,
    });
    assertNoUnsubstitutedTokens(html);
    return html;
  },
};
